import { render, staticRenderFns } from "./CreateIndividualModal.vue?vue&type=template&id=5ba8c945"
import script from "./CreateIndividualModal.vue?vue&type=script&lang=ts"
export * from "./CreateIndividualModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports